module.exports = __webpack_public_path__ + "static/media/no_results.91b6ce74.png";